<template>
  <div class="page-content">
   <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Pricing</h4>
               <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                     <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                     <li class="breadcrumb-item active">Paid Tiers Pricing</li>
                  </ol>
               </div>
            </div>
         </div>
      </div>
      <!-- end page title -->
      <div class="row justify-content-center">
         <div class="col-lg-6">
            <div class="text-center mb-5">
               <h4>Paid Tiers</h4>
               <p class="text-muted">Need something more powerful? Select a plan and deploy a performance equipped Minecraft server. All prices are VAT included.</p>
               <hr>
               <ul class="nav nav-pills nav-justified" role="tablist">
                  <li class="nav-item waves-effect waves-light">
                     <a class="nav-link active" data-toggle="tab" href="#losangeles" role="tab">
                     <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                     <span class="d-none d-sm-block">Los Angeles, USA</span>
                     </a>
                  </li>
                  <li class="nav-item waves-effect waves-light">
                     <a class="nav-link" data-toggle="tab" href="#london" role="tab">
                     <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                     <span class="d-none d-sm-block">London, UK (Coming Soon)</span>
                     </a>
                  </li>
                  <li class="nav-item waves-effect waves-light">
                     <a class="nav-link" data-toggle="tab" href="#amsterdam" role="tab">
                     <span class="d-block d-sm-none"><i class="fas fa-cog"></i></span>
                     <span class="d-none d-sm-block">Amsterdam, NL (Coming Soon)</span>
                     </a>
                  </li>
               </ul>
            </div>
         </div>
      </div>
      <div class="tab-content">
         <div class="tab-pane active" id="losangeles" role="tabpanel">
            <div class="row justify-content-left">
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>1GB RAM</h4>
                              <p class="text-muted">Perfect plan to play with your friends.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£3.98 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-primary btn-sm waves-effect waves-light">SELECT</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>2GB RAM</h4>
                              <p class="text-muted">Providing increased performance for your server.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£7.96 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-primary btn-sm waves-effect waves-light">SELECT</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>3GB RAM</h4>
                              <p class="text-muted">More power for your server!</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£11.94 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-primary btn-sm waves-effect waves-light">SELECT</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>4GB RAM</h4>
                              <p class="text-muted">Most popular plan for price to performance!</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£15.92 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-primary btn-sm waves-effect waves-light">SELECT</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>5GB RAM</h4>
                              <p class="text-muted">Perfect plan for running modpacks.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£19.90 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-primary btn-sm waves-effect waves-light">SELECT</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>6GB RAM</h4>
                              <p class="text-muted">Popular plan amongst smaller server communities.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£23.88 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-primary btn-sm waves-effect waves-light">SELECT</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>8GB RAM</h4>
                              <p class="text-muted">Increased capacity for larger communities.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£31.84 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-primary btn-sm waves-effect waves-light">SELECT</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>10GB RAM</h4>
                              <p class="text-muted">Best available performance on our shared plans.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£47.76 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-primary btn-sm waves-effect waves-light">SELECT</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row justify-content-center">
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>SpaceMine Extreme</h4>
                              <p class="text-muted">Utilizing dedicated servers for maximum performance achievable.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5><sup><small>From</small></sup> £59.99<span class="font-size-13"> /Per month</span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <!-- end LOS ANGELES row -->
         </div>
         <!-- BEGIN LONDON row -->
         <div class="tab-pane" id="london" role="tabpanel">
            <div class="row justify-content-left">
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>1GB RAM</h4>
                              <p class="text-muted">Perfect plan to play with your friends.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£3.98 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>2GB RAM</h4>
                              <p class="text-muted">Providing increased performance for your server.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£7.96 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>3GB RAM</h4>
                              <p class="text-muted">More power for your server!</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£11.94 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>4GB RAM</h4>
                              <p class="text-muted">Most popular plan for price to performance!</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£15.92 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>5GB RAM</h4>
                              <p class="text-muted">Perfect plan for running modpacks.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£19.90 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>6GB RAM</h4>
                              <p class="text-muted">Popular plan amongst smaller server communities.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£23.88 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>8GB RAM</h4>
                              <p class="text-muted">Increased capacity for larger communities.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£31.84 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>10GB RAM</h4>
                              <p class="text-muted">Best available performance on our shared plans.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£47.76 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row justify-content-center">
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>SpaceMine Extreme</h4>
                              <p class="text-muted">Utilizing dedicated servers for maximum performance achievable.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5><sup><small>From</small></sup> £59.99<span class="font-size-13"> /Per month</span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <!-- end LONDON row -->
         </div>
         <!-- start AMSTERDAN row -->
         <div class="tab-pane" id="amsterdam" role="tabpanel">
            <div class="row justify-content-left">
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>1GB RAM</h4>
                              <p class="text-muted">Perfect plan to play with your friends.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£3.98 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>2GB RAM</h4>
                              <p class="text-muted">Providing increased performance for your server.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£7.96 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>3GB RAM</h4>
                              <p class="text-muted">More power for your server!</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£11.94 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>4GB RAM</h4>
                              <p class="text-muted">Most popular plan for price to performance!</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£15.92 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>5GB RAM</h4>
                              <p class="text-muted">Perfect plan for running modpacks.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£19.90 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>6GB RAM</h4>
                              <p class="text-muted">Popular plan amongst smaller server communities.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£23.88 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>8GB RAM</h4>
                              <p class="text-muted">Increased capacity for larger communities.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£31.84 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>10GB RAM</h4>
                              <p class="text-muted">Best available performance on our shared plans.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5>£47.76 / month<span class="font-size-13"></span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row justify-content-center">
               <div class="col-xl-3 col-md-6">
                  <div class="card plan-box">
                     <div class="card-body p-4">
                        <div class="media">
                           <div class="media-body">
                              <h4>SpaceMine Extreme</h4>
                              <p class="text-muted">Utilizing dedicated servers for maximum performance achievable.</p>
                           </div>
                           <div class="ml-3">
                              <i class="bx bxs-chip h1 text-primary"></i>
                           </div>
                        </div>
                        <div class="py-2" style="text-align:center">
                           <h5><sup><small>From</small></sup> £59.99<span class="font-size-13"> /Per month</span></h5>
                        </div>
                        <div class="text-center plan-btn">
                           <a href="#" class="btn btn-secondary btn-sm waves-effect waves-light">Coming Soon</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <!-- end LONDON row -->
         </div>
         <!--COMPLETE END-->
      </div>
   </div>
   <!-- container-fluid -->
</div>
</template>

<script>
export default{
  name: 'Pricing',
  data () {
    return { }
  }
}</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/management/billing/Pricing.vue